'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { useState } from 'react';

export function SearchBar() {
  const router = useRouter();
  const sp = useSearchParams();
  const [value, setValue] = useState(sp.get('q') ?? '');

  function submit(e: React.FormEvent) {
    e.preventDefault();
    const params = new URLSearchParams(sp.toString());
    const trimmed = value.trim();
    if (trimmed) params.set('q', trimmed);
    else params.delete('q');
    params.delete('offset');
    router.push(`?${params.toString()}`);
  }

  return (
    <form
      onSubmit={submit}
      className="flex w-full overflow-hidden rounded-md border-2 border-amber-500 bg-white shadow-sm focus-within:border-amber-600"
    >
      <input
        type="search"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Search by SKU, OEM number, brand, or model…"
        className="flex-1 px-4 py-3 text-sm text-neutral-800 placeholder:text-neutral-400 focus:outline-none"
      />
      <button
        type="submit"
        className="bg-amber-500 px-6 text-sm font-semibold tracking-wide text-white uppercase transition-colors hover:bg-amber-600"
      >
        Search
      </button>
    </form>
  );
}
